<template>
  <textarea v-model="output" :rows="rows" class="form-control"></textarea>
</template>
<script>
  export default {
    props: [
      'val'
    ],
    data: function () {
      return {
        rows: 3,
        output: ''
      }
    },
    created: function () {
      this.output = this.val || ''
      var num = this.output.split(/\n/g).length + 1
      this.rows = (num >= 3) ? num : 3
    },
    watch: {
      'val': function () {
        this.output = this.val
      },
      'output': function () {
        this.onInput()
      }
    },
    methods: {
      onInput () {
        this.output = this.output || ''
        var num = this.output.split(/\n/g).length
        this.rows = (num > 3) ? num : 3
        this.$emit('input', this.output)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// AutoTextArea.vue?af53bbfa